var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",style:({
    'border-right': _vm.width + ' solid rgba(' + _vm.color + ', 0.2)',
    'border-top': _vm.width + ' solid rgba(' + _vm.color + ', 0.2)',
    'border-bottom': _vm.width + ' solid rgba(' + _vm.color + ', 0.2)',
    'border-left': _vm.width + ' solid rgba(' + _vm.color + ', 1)'
  })})}
var staticRenderFns = []

export { render, staticRenderFns }